import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Field, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";

// The id applies on Load rather than per keystroke, so typing "12" does not
// first mount the form for record 1. The form is keyed on the applied id so
// the input resets when the id changes elsewhere (a create, a Clear).
const RecordIdCard = ({ label, description, id, onLoad, onClear }) => {
  const handleSubmit = event => {
    event.preventDefault();
    const value = new FormData(event.currentTarget).get("recordId");
    onLoad(value ? Number(value) : null);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Record</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <form
          key={id}
          onSubmit={handleSubmit}
          className="tw:flex tw:items-end tw:gap-2"
        >
          <Field className="tw:max-w-60">
            <FieldLabel htmlFor="sandbox-record-id">{label}</FieldLabel>
            <Input
              id="sandbox-record-id"
              name="recordId"
              type="number"
              min={1}
              defaultValue={id ?? ""}
            />
          </Field>
          <Button type="submit" variant="outline">
            Load
          </Button>
          <Button
            type="button"
            variant="ghost"
            disabled={id == null}
            onClick={onClear}
          >
            Clear
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default RecordIdCard;
